"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * TPC Lookup
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.LookupValueToJSON = exports.LookupValueFromJSONTyped = exports.LookupValueFromJSON = void 0;
function LookupValueFromJSON(json) {
    return LookupValueFromJSONTyped(json, false);
}
exports.LookupValueFromJSON = LookupValueFromJSON;
function LookupValueFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'key': json['key'],
        'text': json['text'],
    };
}
exports.LookupValueFromJSONTyped = LookupValueFromJSONTyped;
function LookupValueToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'key': value.key,
        'text': value.text,
    };
}
exports.LookupValueToJSON = LookupValueToJSON;
//# sourceMappingURL=LookupValue.js.map